import { Tag } from 'primereact/tag';
import { useTranslation } from 'react-i18next';

import { CertificateStatus } from '../../../../shared/interfaces/ICertificate';
import styles from './CertificateStatusTag.module.css';

type CertificateStatusTagProps = {
  status?: CertificateStatus;
};

const CertificateStatusTag = ({ status }: CertificateStatusTagProps) => {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  const statusConfigMap: Record<
    CertificateStatus,
    { className: string; text: string } | undefined
  > = {
    [CertificateStatus.ACTIVE]: {
      className: styles['active-tag'],
      text: t('certificatesPage.statuses.active'),
    },
    [CertificateStatus.EXPIRED]: {
      className: styles['expired-tag'],
      text: t('certificatesPage.statuses.expired'),
    },
  };

  const config = statusConfigMap[status];

  if (!config) {
    return null;
  }

  return (
    <Tag rounded className={`text-sm font-medium px-2 py-1 ${config.className} w-fit`}>
      {config.text}
    </Tag>
  );
};

export default CertificateStatusTag;
